module.exports = __webpack_public_path__ + "img/landscape-7704393_1280_thumb.f1e4e431.jpg";